export default [
  {
    title: "Merchant",
    customIcon: "CustomerSVG",
    children: [
      {
        title: "Merchant Info",
        route: "custom-module",
        path: "/custom-module/merchant",
      },
    ],
  },
];
